import script from "./terrain_select_panel.vue?vue&type=script&setup=true&lang=js"
export * from "./terrain_select_panel.vue?vue&type=script&setup=true&lang=js"

import "./terrain_select_panel.vue?vue&type=style&index=0&id=73fcf36a&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73fcf36a"]])

export default __exports__